var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "div",
        { staticClass: "btn-box mb10" },
        [
          _c(
            "el-button",
            {
              staticClass: "mb20",
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.addLiaison()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("customer.addliaison")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { staticStyle: { width: "100%" }, attrs: { data: _vm.tableData } },
        [
          _vm._l(_vm.tableHeaders, function (header) {
            return _c("el-table-column", {
              key: header.field,
              attrs: { prop: header.field, label: header.name },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row[header.field] || "--")),
                        ]),
                        _vm._v(" "),
                        header.field == "liaison_name"
                          ? _c("span", [
                              scope.row["e06d7153"] == "0" ? _c("i") : _vm._e(),
                              _vm._v(" "),
                              scope.row["e06d7153"] == "2"
                                ? _c("i", { staticClass: "el-icon-female" })
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row["e06d7153"] == "1"
                                ? _c("i", { staticClass: "el-icon-male" })
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "address",
                width: "110",
                label: _vm.$t("public.operation"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.addLiaison("edit", scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("public.edit")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteLiaison(scope.row, scope.$index)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("public.delete")))]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _vm._v("\n        操作\n        "),
                _c("i", {
                  staticClass: "el-icon-setting pointer",
                  on: { click: _vm.customSearchEvt },
                }),
              ]),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "page-size": _vm.where.limit,
              "current-page": _vm.where.page,
              layout: "total, prev, pager, next, jumper",
              total: _vm.liaisonTotal,
            },
            on: { "current-change": _vm.pageChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("liaison-dialog", {
        ref: "liaisonDialog",
        attrs: { formData: _vm.liaisonConfig },
        on: { isLiaison: _vm.getTableData },
      }),
      _vm._v(" "),
      _vm.tableItemDialogVisible
        ? _c("visible-dialog", {
            attrs: {
              "default-table-item-list": _vm.defaultTableItemList,
              "table-item-dialog-visible": _vm.tableItemDialogVisible,
              "visible-table-item-list": _vm.visibleTableItemList,
              "transfer-data-list": _vm.transferDataList,
              "transfer-props": { key: "field", label: "name" },
            },
            on: {
              handleCloseTableItem: _vm.handleCloseTableItem,
              handleConfirmVisible: _vm.handleConfirmVisible,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }